<div style="margin: 16px 0;">
    <div class="px-4 flex flex-row flex-wrap justify-between items-center content-center">
        <h3 style="font-size: 16px;">Direcciones</h3>
        <button type="button" mat-raised-button mat-button-sm color="primary" class="me-4 mb-4" (click)="openDialog()">
            Agregar dirección
        </button>
    </div>

    <ngx-datatable class="material" [messages]="messages" [rows]="data" [columnMode]="'force'" [headerHeight]="45"
        rowHeight="auto">

        <ngx-datatable-column name="#" [width]="10" [canAutoResize]="false" [sortable]="false" [draggable]="false">
            <ng-template let-value="value" ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                {{ rowIndex + 1 }}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Tipo" [width]="50" prop="tipo_direccion.name"></ngx-datatable-column>
        <ngx-datatable-column name="Dirección" prop="direccion"></ngx-datatable-column>
        <ngx-datatable-column name="Región/Dpto." prop="region.name"></ngx-datatable-column>
        <ngx-datatable-column name="País" prop="country.name_es"></ngx-datatable-column>
       <!--  <ngx-datatable-column *ngIf="district" name="Distrito" prop="distrito"></ngx-datatable-column>  -->
        <ngx-datatable-column name="Acciones" [width]="150" [canAutoResize]="false" [sortable]="false">
            <ng-template let-value="value" ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                <button mat-stroked-button mat-button-sm color="primary" type="button" class="mr-2"
                    (click)="editAddress(row, rowIndex)">
                    <mat-icon>edit</mat-icon>
                </button>
                <button mat-stroked-button mat-button-sm  type="button" (click)="deleteAddress(rowIndex)">
                    <mat-icon>delete</mat-icon>
                </button>
            </ng-template>
        </ngx-datatable-column>

    </ngx-datatable>
</div>